@use 'style/utils';
@use './shared';

:host {
    @include shared.properties();

    font-family: var(--joy-font-family-base);
    line-height: var(--joy-line-height-large);
    font-weight: var(--joy-font-weight-normal);
    display: inline-flex;
}

.joy-company-avatar {
    @include shared.defaultStyle() {
        border: 1px solid var(--avatar-border-color);
        background-color: white;
    }

    &_has-logo {
        background-color: var(--avatar-bg);
    }

    img {
        position: absolute;
        display: block;
        left: 50%;
        top: 50%;
        width: 100%;
        height: 100%;
        transform: translate(-50%, -50%);
        object-fit: cover;
    }

    &_large {
        --avatar-size: 46px;

        font-size: var(--joy-font-size-primary-600);
    }

    &_medium {
        --avatar-size: 30px;

        border-radius: var(--joy-core-radius-2);
        font-size: var(--joy-font-size-primary-300);
    }

    &_small {
        --avatar-size: 20px;

        border-radius: var(--joy-core-radius-1);
        font-size: var(--joy-font-size-primary-100);
    }

    @include utils.avatarColor();
}
